<template>
    <div>
        <form-with-data ref="form" :id="id" :is-edit="isEdit" @submitLoad="submitLoad"></form-with-data>
        <div class="button-div">
            <el-button type="primary" @click="submit" :loading="submitLoading">保存</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
    </div>
</template>
<script>
import formWithData from './withData'
export default {
  components: {
    formWithData
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      submitLoading: false
    }
  },
  methods: {
    submitLoad (val) {
      this.submitLoading = val
    },
    submit () {
      this.$refs.form.submit()
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>
<style module lang="less">

</style>
